'use strict';

const React = require( 'react' );

const PhoneNumber = ( props ) => (
  <div id={ props.id } >{ props.phoneNumber }</div>
);

const propTypes = require('prop-types');
PhoneNumber.propTypes = {
  phoneNumber: propTypes.string.isRequired,
  id: propTypes.string.isRequired
};

module.exports = PhoneNumber;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/phoneNumber.jsx